import TError from './index.vue';

TError.install = app => {
  app.component(TError.name, TError);
};

export default TError;
